import React from "react";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const EventsBanner = () => {
  return (
    <section className="py-6 bg-primary/70">
      <div className="container px-4 md:px-6">
        <motion.div 
          className="relative flex flex-col md:flex-row items-center justify-between gap-4 overflow-hidden rounded-xl bg-white p-4 shadow-sm"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 h-16 w-16 rounded-full bg-primary-100 translate-x-1/2 -translate-y-1/2 opacity-50" />
          <div className="absolute bottom-0 left-0 h-20 w-20 rounded-full bg-indigo-100 -translate-x-1/3 translate-y-1/3 opacity-50" />
          
          {/* Content */}
          <div className="flex items-center gap-4 z-10">
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary-100">
              <Calendar className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900">Upcoming Events</h3>
              <p className="text-sm text-gray-600">Workshops, group sessions, and Q&As with top coaches and therapists</p>
            </div>
          </div>
          
          <Link 
            to="/landing/events" 
            className="group flex items-center gap-1.5 text-secondary/90 font-bold text-sm hover:text-secondary transition-colors z-10"
          >
            See upcoming events
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default EventsBanner;
